import { render, staticRenderFns } from "./QuocTichList.vue?vue&type=template&id=77f8993a&"
import script from "./QuocTichList.vue?vue&type=script&lang=js&"
export * from "./QuocTichList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports